import type { Translations } from '../keys';

const esES: Translations = {
  'common.search': 'Buscar',
  'common.copied': 'Copiado',
  'common.copy': 'Copiar',
  'common.poweredBy': 'Powered by',
  'common.plan': 'Plan',
  'common.banner': 'Banner',
  'common.total': 'Total {value}',
  'common.installmentPrefix': '{count}x de',
  'common.discountCoupon': 'Cupón',
  'common.checkout': 'Pago',
  'common.tryAgain': 'Intentar de nuevo',

  'app.loading': 'Cargando el checkout…',
  'app.init.error': 'Error al inicializar el pago:',

  'checkout.title': 'Completa tu suscripción',
  'checkout.subtitle': 'Completa tus datos para acceder a {productName}.',
  'checkout.greeting': 'Nos alegra verte, {firstName}',
  'checkout.contactInfo': 'Información de contacto',
  'checkout.contact.namePlaceholder': 'Nombre completo',
  'checkout.paymentMethod': 'Método de pago',
  'checkout.cardData': 'Datos de la tarjeta',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Mes',
  'checkout.card.expYear': 'Año',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/AA',
  'checkout.card.holderName': 'Nombre completo del titular de la tarjeta',
  'checkout.document': 'Documento',
  'checkout.document.cpfHolder': 'CPF del titular',
  'checkout.useFilledName': 'Usar el nombre ya introducido',
  'checkout.summary.ariaLabel': 'Resumen de la suscripción',
  'checkout.summary.community': 'Comunidad',
  'checkout.summary.availablePlans': 'Planes disponibles',
  'checkout.summary.chooseAccess': 'Elige tu acceso',
  'checkout.summary.buying': 'Estás comprando:',
  'checkout.summary.renewal': 'Se renovará el {date}. Puedes cancelar cuando quieras.',
  'checkout.theme.enableLight': 'Activar tema claro',
  'checkout.theme.enableDark': 'Activar tema oscuro',
  'checkout.theme.light': 'Claro',
  'checkout.theme.dark': 'Oscuro',
  'checkout.installments.title': 'Cuotas',
  'checkout.installments.placeholder': 'Número de cuotas',
  'checkout.installments.discount': '{percent}% dto.',
  'checkout.submit.generatePix': 'Generar código PIX',
  'checkout.submit.buyLifetime': 'Comprar {productName} (acceso de por vida)',
  'checkout.submit.subscribe': 'Suscribirse a {productName}',
  'checkout.footer.safeTransaction': 'Transacción segura y cifrada',
  'checkout.footer.termsPrefix': 'Al confirmar tu compra, aceptas los',
  'checkout.footer.terms': 'Términos de uso de Ginastee',

  'checkout.notFound.eyebrow': 'Pago no disponible',
  'checkout.notFound.title': 'Comunidad no encontrada',
  'checkout.notFound.description': 'Este enlace de pago no corresponde a una comunidad activa. Verifica la dirección o ponte en contacto con la comunidad.',

  'checkout.paymentsUnavailable.message': 'Los pagos para tu región aún no están disponibles: el responsable de la comunidad debe completar la configuración de su billetera.',
  'checkout.paymentsUnavailable.action': 'Cómo configurarla',

  'coupon.title': 'Cupón de descuento',
  'coupon.placeholder': 'Introduce el cupón',
  'coupon.notFound': 'Cupón no encontrado',

  'pix.title': 'Completa el pago con PIX',
  'pix.instructions': 'Abre una app en la que tengas PIX habilitado y elige la opción "Pagar", luego "Leer código QR"',
  'pix.scanQrCode': 'Escanea el código QR de abajo en la app de tu banco',
  'pix.qrAlt': 'Código QR PIX',
  'pix.copyCode': 'O, si lo prefieres, copia y pega el código de abajo',
  'pix.timeLeft': 'El tiempo para pagar termina en:',
  'pix.realtime': 'Actualizado en tiempo real',

  'thanks.confirming.title': 'Confirmando el pago',
  'thanks.confirming.description': 'Estamos esperando la confirmación del pago antes de darte acceso.',
  'thanks.failed.title': 'Pago no confirmado',
  'thanks.failed.description': 'No pudimos confirmar el pago. Inténtalo de nuevo o contacta con soporte.',
  'thanks.success.title': '¡Enhorabuena!',
  'thanks.success.subtitle': 'Te has suscrito a {productName}',
  'thanks.success.emailSent': 'Te hemos enviado un email con el enlace de acceso a la plataforma.',
  'thanks.success.emailMissing': '¿Aún no has recibido el email?',
  'thanks.success.emailDelay': 'El email de registro suele llegar en un máximo de 5 minutos.',
  'thanks.success.spamSupport': 'Si ya ha pasado ese tiempo, revisa la carpeta de spam o envía un mensaje al canal de soporte.',
  'thanks.success.supportButton': 'El email aún no ha llegado',

  'method.creditCard': 'Tarjeta de crédito',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Introduce tu nombre completo',
  'input.phone.placeholder': 'Número de móvil',
  'input.country.searchPlaceholder': 'Buscar país',
  'input.date.label': 'Fecha',
  'input.date.placeholder': 'dd/mm/aaaa',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Importe',
  'input.money.placeholder': '0,00 €',
  'input.cnpj.label': 'CNPJ',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'correo@ejemplo.com',
  'input.cardNumber.label': 'Número de la tarjeta',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Dirección',
  'address.placeholder': 'Busca tu dirección',
  'address.noOptions': 'No se encontró ninguna dirección',
  'address.number.label': 'Número',
  'address.number.placeholder': 'Nº',
  'address.complement.label': 'Información adicional',
  'address.complement.placeholder': 'Piso, bloque...',
  'address.neighborhood.label': 'Barrio',
  'address.zipcode.label': 'Código postal',
  'address.zipcode.placeholder': '00000',
  'address.city.label': 'Ciudad',
  'address.state.placeholder': 'Provincia',

  'stripe.error.generic': 'Hubo un error al procesar el pago, comprueba los datos introducidos e inténtalo de nuevo',
  'stripe.error.incompleteCard': 'Completa los datos de la tarjeta para continuar',
  'stripe.error.confirmPayment': 'Hubo un error al confirmar el pago',
  'stripe.submit': 'Confirmar pago',

  'payment.error.generic': 'Hubo un error al procesar el pago, comprueba los datos introducidos e inténtalo de nuevo',
  'payment.error.prepare': 'Hubo un error al preparar el pago, comprueba los datos introducidos e inténtalo de nuevo',
  'payment.error.missingCharge': 'No se devolvió el identificador del cobro',
  'payment.error.notApproved': 'Pago no aprobado. Comprueba los datos de la tarjeta e inténtalo de nuevo.',

  'validation.cardNumber': 'Corrige el número de la tarjeta',
  'validation.cardExpiration': 'Fecha de caducidad no válida',
  'validation.cardExpired': 'Tarjeta caducada',
  'validation.cardCvv': 'CVV no válido',
  'validation.cpf': 'CPF no válido',
  'validation.fullName': 'Nombre completo no válido',
  'validation.fullNameLettersOnly': 'El nombre solo debe contener letras',
  'validation.emailRequired': 'El email es obligatorio',
  'validation.emailInvalid': 'Email no válido',
  'validation.phoneRequired': 'El teléfono es obligatorio',
  'validation.phoneInvalid': 'Teléfono no válido',
  'validation.phoneDigits': 'El teléfono debe tener 10 u 11 dígitos',
  'validation.phoneMobileStartsWithNine': 'El móvil debe empezar por 9',
  'validation.phoneDdd': 'Prefijo no válido',

  'interval.week.adjective': 'Semanal',
  'interval.month.adjective': 'Mensual',
  'interval.bimonthly.adjective': 'Bimestral',
  'interval.quarterly.adjective': 'Trimestral',
  'interval.semiannual.adjective': 'Semestral',
  'interval.year.adjective': 'Anual',
  'interval.lifetime.adjective': 'De por vida',
  'interval.week.noun': 'Semana',
  'interval.month.noun': 'Mes',
  'interval.bimonthly.noun': 'Bimestre',
  'interval.quarterly.noun': 'Trimestre',
  'interval.semiannual.noun': 'Semestre',
  'interval.year.noun': 'Año',
  'interval.lifetime.noun': 'De por vida',
  'interval.lifetime.access': 'acceso de por vida',
  'interval.period': 'período',

  'month.01': 'Enero',
  'month.02': 'Febrero',
  'month.03': 'Marzo',
  'month.04': 'Abril',
  'month.05': 'Mayo',
  'month.06': 'Junio',
  'month.07': 'Julio',
  'month.08': 'Agosto',
  'month.09': 'Septiembre',
  'month.10Label': 'Octubre',
  'month.11Label': 'Noviembre',
  'month.12': 'Diciembre',
};

export default esES;
